import { componentSizes, datePickTypes } from '@hd-front-end/constants'

import type { ComponentSize, DatePickType } from '@hd-front-end/constants'

export const isValidComponentSize = (val: string): val is ComponentSize | '' =>
  ['', ...componentSizes].includes(val)

export const isValidDatePickType = (val: string): val is DatePickType =>
  ([...datePickTypes] as string[]).includes(val)
